export default "__VITE_ASSET__6fjcV5qg__"